import { api } from "../api";
import { API_BASE_URL } from "../../env";

// Client-side cache: audioId → { token, expiresAt }
const streamTokenCache = new Map<string, { token: string; expiresAt: number }>();

export const audioApi = {
    /**
     * Get a backend-proxied stream URL for an audio.
     *
     * Fetches a short-lived opaque stream token via POST (JWT sent in
     * Authorization header, never in URL), then builds the stream URL
     * with the opaque token as the query param.
     */
    async getStreamUrl(audioId: string): Promise<string> {
        // Reuse cached token if it won't expire in the next 60 s
        const cached = streamTokenCache.get(audioId);
        if (cached && cached.expiresAt > Date.now() + 60_000) {
            return `${API_BASE_URL}/audios/${audioId}/stream?stream_token=${encodeURIComponent(cached.token)}`;
        }

        const { data } = await api.post<{ stream_token: string; expires_in: number }>(
            `/audios/${audioId}/stream-token`,
        );

        streamTokenCache.set(audioId, {
            token: data.stream_token,
            expiresAt: Date.now() + data.expires_in * 1000,
        });

        return `${API_BASE_URL}/audios/${audioId}/stream?stream_token=${encodeURIComponent(data.stream_token)}`;
    },
};
